import React from "react";
import { Card } from "antd";
// import { Link } from "react-router-dom";

const Meta  = Card.Meta;
export default function CardComponent1({ title, description, link , image}) {
  const openLinkInNewWindow = () => {
    window.open(link, "_blank");
  };
  return (
    <div className="card" onClick={openLinkInNewWindow}>
      <Card hoverable
         style={{
      width: 250,
      height: 250,
      borderRadius:'12px 12px 8px 8px',
    }}
    cover={
      <img
        alt={description}
        src={image}
      />
      
    }
    >
    <Meta title={title} description={description} />
      </Card>
    </div>
  );
}
